module.exports = __webpack_public_path__ + "img/nav_6_active.091ab89f.gif";